import React from 'react';
import { ShieldCheck, MapPin, CheckCircle2 } from 'lucide-react';

export const TrustSection = () => {
    return (
        <section style={{ padding: '120px 0', borderTop: '1px solid var(--border-subtle)', background: 'var(--bg-secondary)', position: 'relative' }}>
            <div className="container" style={{ position: 'relative', zIndex: 1 }}>
                <div style={{ textAlign: 'center', marginBottom: '80px', maxWidth: '800px', margin: '0 auto 80px auto' }}>
                    <h2 style={{ fontSize: 'clamp(2.5rem, 5vw, 3.5rem)', letterSpacing: '-0.02em', marginBottom: '24px' }}>
                        Local Trust. Global Standards.
                    </h2>
                    <p style={{ color: 'var(--text-tertiary)', fontSize: '1.25rem', lineHeight: 1.6 }}>
                        Proudly registered, operated, and supported to the highest global standards.
                    </p>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '32px' }}>

                    <div className="glass-panel" style={{ padding: '40px', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', border: '1px solid var(--border-focus)' }}>
                        <ShieldCheck size={32} color="var(--accent-primary)" style={{ marginBottom: '24px' }} />
                        <h3 style={{ fontSize: '1.25rem', fontWeight: 600, marginBottom: '16px' }}>Secure & Certified Payments</h3>
                        <p style={{ color: 'var(--text-secondary)', marginBottom: '24px', lineHeight: 1.6 }}>
                            All transactions are encrypted and processed by PCI-compliant global payment gateways. Your funds settle directly to your business account.
                        </p>
                        <div style={{ display: 'flex', gap: '8px', color: 'var(--text-tertiary)', fontSize: '0.875rem' }}>
                            <CheckCircle2 size={16} color="#10B981" /> Stripe & Global Providers Integrated
                        </div>
                    </div>

                    <div className="glass-panel" style={{ padding: '40px', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', border: '1px solid var(--border-focus)' }}>
                        <MapPin size={32} color="var(--accent-secondary)" style={{ marginBottom: '24px' }} />
                        <h3 style={{ fontSize: '1.25rem', fontWeight: 600, marginBottom: '16px' }}>Registered Business Entity</h3>
                        <p style={{ color: 'var(--text-secondary)', marginBottom: '24px', lineHeight: 1.6 }}>
                            Ordabell is powered and owned tightly by Fiescrow LLC, dedicated to elevating the hospitality sector on a global scale.
                        </p>
                        <div style={{ display: 'flex', gap: '8px', color: 'var(--text-tertiary)', fontSize: '0.875rem' }}>
                            <CheckCircle2 size={16} color="#10B981" /> Verified Entity | 24/7 Global support
                        </div>
                    </div>

                </div>

                <div style={{ marginTop: '64px', padding: '48px', textAlign: 'center', background: 'var(--bg-tertiary)', borderRadius: '16px', border: '1px solid var(--border-subtle)' }}>
                    <p style={{ fontSize: '1.5rem', fontStyle: 'italic', color: 'var(--text-primary)', marginBottom: '24px', maxWidth: '800px', margin: '0 auto 24px auto' }}>
                        "Since implementing Ordabell, our guests have stopped complaining about delayed service. The tables turn over much faster, and our daily revenue has noticeably increased. It's a game changer for premium lounges."
                    </p>
                    <div style={{ fontWeight: 600 }}>Tunde O.</div>
                    <div style={{ color: 'var(--text-secondary)', fontSize: '0.875rem' }}>Manager, Premium Lounge (London)</div>
                </div>

            </div>
        </section>
    );
};
